import React, { useContext } from "react";
import PropTypes from "prop-types";

import ElementContext from "../../../components/ElementContext";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./iconTextPair.module.less";
import Link from "../../../components/Link";

/**
 * Display a string (e.g., phone number, email) preceeded by an icon
 */
function IconTextPair({ contactString, icon, type }) {
    const { isLightBg } = useContext(ElementContext);
    if (typeof contactString !== "string") {
        return;
    }
    return (
        <>
            {contactString && (
                <div
                    className={gcs(
                        styles.iconTextPair,
                        !isLightBg ? styles.lightColor : ""
                    )}
                >
                    {/* TODO what icon type*/}
                    <img src={icon} loading="lazy" alt={"TODO"} />

                    {(() => {
                        switch (type) {
                            case "phone":
                                return (
                                    <Link
                                        to={`tel:${contactString}`}
                                        target="_blank"
                                        linkClass={styles.contactString}
                                    >
                                        {contactString}
                                    </Link>
                                );
                            case "email":
                                return (
                                    <Link
                                        to={`mailto:${contactString}`}
                                        target="_blank"
                                        linkClass={styles.contactString}
                                    >
                                        {contactString}
                                    </Link>
                                );
                            default:
                                return (
                                    <span className={styles.contactString}>
                                        {contactString}
                                    </span>
                                );
                        }
                    })()}
                </div>
            )}
        </>
    );
}
IconTextPair.propTypes = {
    contactString: PropTypes.string,
    // TODO what icon type
    icon: PropTypes.any.isRequired
};
export { IconTextPair };
